import angular from 'angular';

export const BuildiumCacheModule = angular.module('buildium.cache', [])
    .service('SeedData', angular.noop);
